<template>
  <div class="examSeting">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <!-- 基础信息 -->
      <el-tab-pane label="基础信息" name="1">
        <div class="addExam">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
            <el-form-item label="考试名称" prop="name">
              <el-input v-model="ruleForm.name" placeholder="考试名称"></el-input>
            </el-form-item>
            <el-form-item label="考试地点" prop="address">
              <el-input v-model="ruleForm.address" placeholder="考试地点"></el-input>
            </el-form-item>
            <el-form-item label="所属父考试" prop="parentId">
              <el-select v-model="ruleForm.parentId" placeholder="所属父考试">
                <el-option v-for="item in option" :key="'fa'+item.id" :label="item.name" :value="item.pid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试顺序" prop="examOrder">
              <el-select v-model="ruleForm.examOrder" placeholder="考试顺序">
                <el-option label="轮询" :value="3"></el-option>
                <el-option label="顺序" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排考方式" prop="examWay">
              <el-select v-model="ruleForm.examWay" placeholder="考试顺序">
                <el-option label="已考场分组" :value="1"></el-option>
                <el-option label="已考站分组" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="checked">
              <el-checkbox v-model="ruleForm.checked">要求考生同时进出考站（考站的时间采用最长考站时间）</el-checkbox>
            </el-form-item>
            <el-form-item prop="realtime">
              <el-checkbox v-model="ruleForm.realtime">实时发布成绩</el-checkbox>
            </el-form-item>
            <el-form-item label="考试时间" prop="">

              <el-button type="primary" @click="addTime()" size="medium" class="add">新增时间</el-button>
              <el-table :data="timeList" border style="width: 1000px">

                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="address" label="开始时间">
                  <template slot-scope="scope">
                    <el-date-picker v-model="scope.row.begin_dt" @blur="blurTime(scope.row)" class="time" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="开始时间">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="结束时间">
                  <template slot-scope="scope">
                    <el-date-picker v-model="scope.row.end_dt" class="time" format="yyyy-MM-dd HH:mm" @blur="blurTime1(scope.row)" value-format="yyyy-MM-dd HH:mm" type="datetime" placeholder="结束时间">
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="时长">
                  <template slot-scope="scope">
                    {{formatDuring(new Date(scope.row.end_dt) - new Date(scope.row.begin_dt))}}

                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="godetele(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')" size="medium">保存</el-button>
              <el-button @click="resetForm('ruleForm')" size="medium">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
      <!-- 考场安排 -->
      <el-tab-pane label="考场安排" name="2">
        <ul class="firstUl">
          <li v-for="(itemfirst,index) in firstList" :key="'arrange'+index">

            <div class="zhanfirst">
              <div class="name"> 第{{index+1}}站</div>
<!--              <div class="zhanname">-->
<!--                <label>站名：</label>-->
<!--                <el-input v-model="itemfirst.name" placeholder="请输入站名"></el-input>-->
<!--              </div>-->
              <div class="selectRight">
                <!-- <el-select v-model="value" placeholder="请选择">
                  <el-option label="选考" value="shanghai"></el-option>
                  <el-option label="必考" value="beijing"></el-option>
                </el-select> -->
                <el-button type="danger" size="medium" @click="delBig(index,itemfirst)">删除</el-button>
              </div>
            </div>

            <!-- 表格 -->
            <el-table :data="itemfirst.item" border >

              <el-table-column label="考站" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.station_id" placeholder="请选择" filterable clearable @focus="stationList" @change="blurs(scope.row,itemfirst,1)">
                    <el-option v-for="item in selectList" :key="'station'+item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="考站类型"  align="center">

                <template slot-scope="scope">
                  <span v-if="scope.row.station_type==1"> 技能考站</span>
                  <span v-if="scope.row.station_type==2"> 理论考站</span>
                </template>

              </el-table-column>
              <el-table-column prop="address" label="考试项目" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.subject_id" placeholder="请选择" @focus="stationSubjects(scope.row)" filterable clearable @change="blurs(scope.row,itemfirst,2)">
                    <el-option v-for="item in stationSubList" :key="'subject'+scope.$index+scope.row.station_id+item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="address" label="所属考场" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.room_id" placeholder="请选择" filterable clearable @focus="getRoomList" @change="blurs(scope.row,itemfirst,3)">
                    <el-option v-for="item in roomsList" :key="'room'+scope.$index+scope.row.station_id+item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="success" size="small" @click="goadd(scope.$index,index,scope.row,itemfirst)">添加</el-button>
                  <el-button type="danger" size="small" @click="godel(scope.$index,index,scope.row,itemfirst)">删除</el-button>

                </template>
              </el-table-column>
            </el-table>
            <!-- 表格 -->

          </li>
        </ul>
        <div class="btngroup">
          <el-button size="medium" type="primary" @click="saveArrange">保存考场安排</el-button>
          <el-button size="medium">取消</el-button>
          <el-button size="medium" type="primary" @click="addKz">新增考站</el-button>
        </div>

        <div>

        </div>
      </el-tab-pane>
      <!-- 考官安排 -->
      <el-tab-pane label="考官安排" name="3" @click="examTeacherarrange">
        <el-table :data="TeachList" border style="width: 100%" >

          <el-table-column prop="subject_name" label="考试项目"  align="center" >
          </el-table-column>
          <el-table-column prop="station_name" label="考站" align="center">
          </el-table-column>
          <el-table-column prop="station_type" label="类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.station_type==1"> 技能考站</span>
              <span v-if="scope.row.station_type==2"> 理论考站</span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="考官"  align="center" >
            <template slot-scope="scope">
              <div class="items">
                <el-select v-model="teacherIds[scope.$index]" multiple placeholder="请选择" @focus="focus2(scope.row)" @change="saveTearch(scope.$index,scope.row)">
                  <el-option v-for="item in TeachLists" :key="'teacher'+item.teacher_id" :label="item.name" :value="item.teacher_id">

                  </el-option>
                </el-select>
                <el-button size="mini" type="text" @click="addTearch">新增考官</el-button>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="address" label="时段" align="center">
            <template slot-scope="scope">
              {{scope.row.begin_dt}}~{{scope.row.end_dt}}

            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="godetele(scope.$index)">删除</el-button>

            </template>
          </el-table-column> -->
        </el-table>
        <div class="btngroup">
          <el-button size="medium" type="primary" @click="saveTearchs">保存</el-button>
          <el-button size="medium" @click="$router.go(-1)">取消</el-button>
        </div>
      </el-tab-pane>
      <!-- 考生管理 -->
      <el-tab-pane label="考生管理" name="4" @click="getData">
        <div>
          <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
              <el-form-item>
                <el-input v-model="formInline.name" placeholder="姓名、学号、身份证号、电话"></el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" size="medium" @click="search">查询</el-button>
                <el-button type="success" size="medium" @click="addStudent">新增考生</el-button>
                <el-button type="primary" size="medium" @click="exportFn">下载模版</el-button>

                <el-upload class="upload-demo" :action="uploadUrl2" :data="datas" :headers="headers1" :show-file-list="false" :on-success="handleAvatarSuccess1" style="display:inline-block">
                  <el-button type="primary" size="medium">导入考生</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <el-table :data="tableData" stripe style="width: 100%">

            <el-table-column prop="name" label="考试姓名">
            </el-table-column>
<!--            <el-table-column prop="name" label="性别">-->
<!--              <template slot-scope="scope">-->
<!--                {{scope.row.begin_dt}}-{{scope.row.end_dt}}-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column prop="code" label="学号">

            </el-table-column>
            <el-table-column prop="idcard" label="身份证号">
            </el-table-column>
            <el-table-column prop="exam_sequence" label="准考证号">
            </el-table-column>
            <el-table-column prop="grade_class" label="班级">

            </el-table-column>
            <el-table-column prop="teacher_name" label="班主任姓名">

            </el-table-column>
            <el-table-column prop="mobile" label="联系电话">

            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">

                <!-- <el-button type="text" size="small">查看</el-button> -->
                <el-button type="text" size="small" @click="editStudent(scope.row)">编辑</el-button>
                <el-button type="text" size="small" @click="delStudent(scope.row,scope.$index)"> 删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: right;margin-top:20px">
            <el-pagination background @current-change="pageCurrentChange" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="total, prev, pager, next" :total="pageform.total" :page-size='10'>
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
      <!-- 智能排考 -->
      <el-tab-pane label="智能排考" name="5" @click="showArrange">
        <!-- 拍考 -->
        <div class="wraps">
          <ul class="ul1">
            <li v-for="(value1, key1, index1) in object" :key="'k'+index1" class="">

              <ul class="ul2">
                <li v-for="(value2, key2, index2) in value1" :key="'kk'+index2" class="" style="overflow:hidden">
                  <!-- 左侧标尺 -->
                  <ul class="ulleft">
                    <li v-for="(value3, key3, index3) in value2" :key="'kkk'+index3" class="">

                      <div v-if="key3=='name'" class="roomName roomName1"></div>
                      <ul v-if="key3=='child'" class="">

                        <li v-for="(value4, key4, index4) in value3" :key="'kkkk'+index4" class="">
                          <ul class="">
                            <li v-for="(value5, key5, index5) in value4" :key="'kkkkk'+index5">
                              <div v-if="key5=='start'" class="timeindex">{{$format(new Date(value5),'MM-dd hh:mm')  }}--</div>
                              <div class="timeindex" v-if="key5=='end'&&index4==Object.keys(value3).length-1">{{$format(new Date(value5),'MM-dd hh:mm')  }}--</div>

                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                  </ul>
                  <!-- 右侧内容 -->
                  <ul class="ul3">
                    <li v-for="(value3, key3, index3) in value2" :key="'ky'+index3" class="li3">

                      <div v-if="key3=='name'" class="roomName">{{value3}}</div>
                      <ul v-if="key3=='child'" class="ul4">

                        <li v-for="(value4, key4, index4) in value3" :key="'kyy'+index4" class="li4">
                          <ul class="ul5">
                            <li v-for="(value5, key5, index5) in value4" :key="'kyyy'+index5">
                              <!-- <div v-if="key5=='start'">{{$format(new Date(value5),'MM-dd hh:mm')  }}</div>
                              <div v-if="key5=='end'&&index4==Object.keys(value3).length-1">{{$format(new Date(value5),'MM-dd hh:mm')  }}话</div> -->
                              <div v-if="key5=='items'" class="li5">
                                <span class="" v-for="(value6,key6, index6) in value5">
                                  {{value6.name}}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>

                  </ul>
                </li>
              </ul>

            </li>
          </ul>

        </div>
        <!-- 拍考 -->

        <div class="btnbox">
          <el-button type="primary" size="medium" @click="mindarrangement">智能排考</el-button>
          <el-button size="medium" type="primary" @click="savearrangement">保存方案</el-button>

        </div>
      </el-tab-pane>
      <!-- 待考区说明 -->
      <el-tab-pane label="待考区说明" name="6">
        <el-form :model="ruleForm2" label-width="100px" class="demo-ruleForm">
          <el-form-item label="说明内容:" class="fwbWrap">
            <quill-editor class="editor fwb" ref="myTextEditor" v-model="ruleForm2.desc" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)" @change="onEditorChange($event)">
            </quill-editor>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" @click="examWaiting()">保存</el-button>
            <el-button size="medium" @click="$router.go(-1)">取消</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 新增考官 -->
    <el-dialog title="新增考官" :visible.sync="dialogVisible" class="dialogs" :before-close="handleClose">
      <el-form :model="teacherInfo" :rules="ruless" ref="teacherInfo" label-width="150px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="teacherInfo.name" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatar">
          <el-upload class="avatar-uploader" :action="uploadUrl" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="{type:'avatar'}">
            <img v-if="teacherInfo.avatar " :src="GLOBAL.BASE_URL+teacherInfo.avatar " class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="teacherInfo.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="教师编号" prop="code">
          <el-input v-model="teacherInfo.code" placeholder="学号"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="teacherInfo.idcard" placeholder="身份证号"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="mobile">
          <el-input v-model="teacherInfo.mobile" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="teacherInfo.email" placeholder="邮箱"></el-input>
        </el-form-item>
        <el-form-item label="支持考试项目" prop="subjects">
          <el-select v-model="teacherInfo.subjects" placeholder="请选择支持考试项目" multiple filterable clearable @focus="allSubjects" @change="test">
            <el-option v-for="item in subList" :key="'subjects'+item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveTea('teacherInfo')" size="medium">保存</el-button>
          <el-button @click="resetForm('teacherInfo')" size="medium">取消</el-button>
        </el-form-item>
      </el-form>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
  </div>

</template>

<script>
export default {
  props: {

  },
  data() {
    return {
      ruleForm2: {
        desc: ''
      },
      headers1: {
        Authorization: 'Bearer' + this.$cookies.get('token')
      },
      //   config.headers.Authorization = "Bearer " +VueCookies.get('token')
      dialogVisible: false,
      teacherInfo: {
          name: '',
          mobile: '',
          email: '',
          code: '',
          idcard: '',
          avatar: '',
          gender: 1
      },
      datas: {
        exam_id: this.$route.query.id
      },
      uploadUrl: this.GLOBAL.BASE_URL + 'api/images',
      ruless: {
        name: [
          { required: true,  message: '请输入姓名', trigger: 'blur' },
          { min: 2, max:10, message: '长度在2到10个字符', trigger: 'blur' },
          { required: true, pattern:/^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,message: '姓名不支持特殊字符', trigger: 'blur' },

        ],
        idcard: [
          { required: false, pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '请输入正确的身份证号码', trigger: 'blur' }
        ],

        email: [
            { required: false, message: '请输入邮箱地址', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur'] }

        ],

        mobile: [
            { required: true,message: '请输入手机号', trigger: 'blur'},
            { required: true,pattern: /^1[34578]\d{9}$/,message: '目前只支持中国大陆的手机号码', trigger: 'blur'},

        ],
          subjects: [
          { required: true, message: '请选择支持考试项目', trigger: 'blur' }
        ],

      },
      timeList: [],
      projectList: [],
      index: '',
      imageUrl: '',
      uploadUrl2: this.GLOBAL.BASE_URL + 'api/exam/import-student',
      input: "",
      activeName: '1',
      option: [],
       teacherIds:[],
      ruleForm: {
        name: '',
        address: '',
        parentId: '',
        checked: false,
        stage: '',
        examOrder: 3,
        examWay: 1,
        realtime: false,

      },
      rules: {
        name: [
          { required: true, message: '请输入考试名称', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请选择考试地点', trigger: 'change' }
        ],
      },
      firstList: [],
      twoList: [],
      id: '',
      gradationid: '',
      selectList: [],
      subList: [],
      object:[],
      stationSubList: [],
      roomsList: [],
      order: '',
      draft_id: '',
      bigId: '',//大站返回的id
      tearchList: [],
      formInline: {
        name: ''
      },

      // 分页插件
      pageform: {
        total: 10,
        pages: 10,  // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 10, // 每页显示条目个数
      },

      tableData: [],
      isAdd: true,
      TeachList: null,//考官列表
      TeachLists: [],
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{ header: 1 }, { header: 2 }], // 1、2 级标题
            [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 字体大小
            [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
            [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
            [{ font: [] }], // 字体种类
            [{ align: [] }], // 对齐方式
            ["clean"], // 清除文本格式
            //   ["link", "image", "video"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
        syntax: true, //语法检测
      }
    };
  },
  computed: {

  },
  created() {
    this.id = this.$route.query.id
    if (window.sessionStorage.getItem('tabIndex')) {
      this.activeName = window.sessionStorage.getItem('tabIndex');
    }
    if (this.id) {
      this.examDetails()
      this.allGradations();
      this.examArrangedata();
      //   this.roomList()//考场
      //   this.stationList()//考站
         this.allSubjects()//考试项目
      this.examTeacherarrange()//考官列表
      this.getData()//获取考生列表
      this.showArrange()//智能排考回显数据
      this.examsList()//考试列表
    }
  },

  methods: {
      test(va){
          console.log(va);
      },
    //保存排考
    savearrangement() {
      this.$http
        .storeArrange(
          {
            exam_id: this.id
          }
        )
        .then(res => {
          if (res.code == 1) {
             // this.object = res.data;
            this.$message.success("保存成功")

          } else {
            this.$message.error(res.message)
          }


        })
        .catch(err => {
          console.log(err);
        });
    },
    //智能排考
    mindarrangement() {
      if (this.tableData.length <= 0) {
        this.$message.error("当前没有考生，请先添加考生！")
          return false;
      } else {
          if (this.TeachLists.length<=0)
          {
              this.$message.error("当前没有考官，请先安排考官！")
              return false;
          }
        this.$http
          .beginArrange(
            {
              exam_id: this.id
            }
          )
          .then(res => {
            if (res.code == 1) {
              this.object = res.data;
              this.$message.success("排考成功")
            } else {
              this.$message.error(res.message)
            }


          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //智能排考回显showArrange

    showArrange() {

      this.$http
        .showArrange(
          {
            exam_id: this.id
          }
        )
        .then(res => {
          if (res.code == 1) {
            this.object = res.data;
          } else {
            this.$message.error(res.message)
          }


        })
        .catch(err => {
          console.log(err);
        });

    },
    // 失去焦点
    onEditorBlur(editor) { },
    // 获得焦点
    onEditorFocus(editor) { },
    // 开始
    onEditorReady(editor) { },
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
    },
    //saveTea
    saveTea(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http
            .addTeachers(this.teacherInfo)
            .then(res => {
              if (res.data) {
                this.$message.success("新增成功")
                this.dialogVisible = false;
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(err => {
              console.log(err);
            });


        } else {
          this.$message.error("请填写必填项")
          return false;
        }
      });

    },
    handleAvatarSuccess(res, file) {
        this.teacherInfo.avatar = res.data.path
    },
    handleAvatarSuccess1(res, file) {


      if (res.code == 1) {
        this.$message.success(res.message);
        this.getData();
      } else {
        this.$message.error(res.message);
      }

    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    //
    handleClose(done) {
      this.dialogVisible = false;
      this.$refs['teacherInfo'].resetFields();
    },
    //新增考官
    addTearch() {
      this.dialogVisible = true;

    },
    //删除考试
    delStudent(item, index) {
      this.$confirm('确定要删除该数据吗？')
        .then(_ => {
          this.$http.delStudent({
            exam_id: this.id,
            id: item.id,
          })
            .then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功")
                this.tableData.splice(index, 1)

              } else {
                this.$message.error(res.message)
              }
            })
            .catch(err => {
              console.log(err);
            })
        })
        .catch(_ => { });
    },
    //下载学生模版
    exportFn() {
      window.open(this.GLOBAL.BASE_URL + "download/student.xlsx")
    },
    //保存全部考试信息
    saveTearchs() {
      var data = [];
      for (var i = 0; i < this.TeachList.length; i++) {
        var obj = {
          subject_id: this.TeachList[i].subject_id,
          station_id: this.TeachList[i].station_id,
          exam_screening_id: this.TeachList[i].exam_screening_id,
          exam_gradation_id: this.TeachList[i].exam_gradation_id,
          teacher: this.teacherIds[i]
        }
        data.push(obj)
      }
      this.$http.invigilatearrange({
        exam_id: this.id,
        data: data,
      })
        .then(res => {
          if (res.code == 1) {
            this.$message.success("保存成功")

          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })
    },
     //保存单条考官

    saveTearch(index,row) {
    //     this.$http.invigilatearrange({
    //     exam_id: this.id,
    //     subject_id: row.subject_id,
    //     station_id: row.station_id,
    //     exam_screening_id: row.exam_screening_id,
    //     exam_gradation_id: row.exam_gradation_id,
    //     teacher: this.teacherIds[index],
    //   })
    //     .then(res => {
    //         this.$forceUpdate()
    //     })
    //     .catch(err => {
    //         this.$message.error(err.message)
    //     })

    },
    focus2(row) {
      console.log(row)
      this.invigilatesbysubject(row)

    },
    //删除大类
    delBig(index, item) {
      this.$confirm('确定要删除该数据吗？')
        .then(_ => {
          this.$http.delExamflow({
            exam_id: this.id,
            flow_id: item.id,
            type: 2,

          })
            .then(res => {
              if (res.code !== 0) {
                this.firstList.splice(index, 1)

              } else {
                this.$message.error(res.message)
              }

            })
            .catch(err => {
              console.log(err);
            })
        })
        .catch(_ => { });

    },
    //删除小类
    godel(index1, index2, item2, item1) {
      this.$confirm('确定要删除该数据吗？')
        .then(_ => {

          if (item1.item.length <= 1) {

            this.$http.delExamflow({
              exam_id: this.id,
              flow_id: item1.id,
              type: 2,
            })
              .then(res => {
                if (res.code !== 0) {
                  this.firstList.splice(index1, 1)

                } else {
                  this.$message.error(res.message)
                }

              })
              .catch(err => {
                console.log(err);
              })

          } else {
            this.$http.delExamdraft({
              exam_id: this.id,
              type: 5,
              draft_id: item2.id,
              flow_id: item1.id,
            })
              .then(res => {
                if (res.code !== 0) {
                  this.firstList[index2].item.splice(index1, 1)

                } else {
                  this.$message.error(res.message)
                }

              })
              .catch(err => {
                console.log(err);
              })
          }

        })
        .catch(_ => { });

    },

    //保存考试安排
    saveArrange(flag) {
      this.$http.arrangeSave({
        exam_id: this.id,
        flag:flag?flag:0
      })
        .then(res => {
          if (res.code ==1) {
              this.isAdd = false;
              this.$message.success('保存成功')
          } else if (res.code ==-1) {
              this.$confirm('考试项目更改将导致智能排考重排，确定修改吗？')
                  .then(_ => {
                      this.saveArrange(1)
                  })
                  .catch(_ => { });
          }

        })
        .catch(err => {
          console.log(err);
        })
    },

    //新增大站里面的小站
    goadd(index1, index2, row2, row1) {
      this.$http.addExamDraft({
        exam_id: this.id,
        exam_gradation_id: this.gradationid,
        type: 4,
        flow_id: this.bigId || row1.id,
        // draft_id: this.draft_id||row1.id,
        station_id: row2.station_id,
        room_id: row2.room_id,
        subject_id: row2.subject_id,
      })
        .then(res => {
          if (res.code !== 0) {
            // this.draft_id = res.draft_id;
            // this.examArrangedata();
            // this.roomList()
            this.draft_id = res.data.id
            this.firstList[index2].item.push({
              station_id: '',
              room_id: '',
              subject_id: '',
              id: res.data.id,
            })

          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })
    },

    //examArrangedata
    //获取考试安排数据的回显
    examArrangedata() {
      this.$http.examArrangedata({
        exam_id: this.id
      })
        .then(res => {
          if (res.code !== 0) {
            this.firstList = res.data;
            this.isAdd = false;
            for (var i = 0; i < this.firstList.length; i++) {
              if (this.firstList[i].item.length) {
                for (var j = 0; j < this.firstList[i].item.length; j++) {
                  this.selectList.push({
                    name: this.firstList[i].item[j].station_name,
                    id: this.firstList[i].item[j].station_id,
                  })
                  this.stationSubList.push({
                    name: this.firstList[i].item[j].subject_name,
                    id: this.firstList[i].item[j].subject_id,
                  })
                  this.roomsList.push({
                    name: this.firstList[i].item[j].room_name,
                    id: this.firstList[i].item[j].room_id,
                  })

                  //                 selectList: [],
                  //   subList: [],
                  //   roomsList: [],
                }
              }
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //新增考站
    addKz() {
      this.$http.addExamFlow({
        exam_id: this.id,
        exam_gradation_id: this.gradationid,
        // type: 1,
        order: 1,
      })
        .then(res => {
          if (res.code !== 0) {
            this.draft_id = res.data.draft_id;
            this.bigId = res.data.id;
            this.isAdd = true;
            this.firstList.push(
                  {
                      id:res.data.id,
                      name: '',
                      item: [
                          {
                              station_id: '',
                              room_id: '',
                              subject_id: '',
                              id: res.data.draft_id,
                          }
                      ]
                  }
              )
          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取order
    blurs(row2, row1,key) {
      row2.station_type = 1;
      this.$http.addExamDraft({
        exam_id: this.id,
        exam_gradation_id: this.gradationid,
        type: this.isAdd ? 3 : 2,
        flow_id: this.bigId || row1.id,
        draft_id: this.draft_id || row2.id,
        station_id: row2.station_id,
        room_id: row2.room_id,
        subject_id: row2.subject_id,
      })
        .then(res => {
          if (res.code !== 0) {
            //this.$message.success(res.message)
              if (key==1)
              {
                  row2.subject_id=''
                  this.stationSubjects(row2)

              }else if (key==2)
              {
                  row2.room_id=''
                  this.getRoomList()
              }
          } else {
            this.$message.error(res.message)
          }

        })
        .catch(err => {
          console.log(err);
        })

    },
    // 获取考试详情
    examDetails() {
      this.$http.examDetails(this.id)
        .then(res => {
          if (res.code !== 0) {
            var examData = res.data.examData;
            var examScreeningData = res.data.examScreeningData;
            //  sequence_cate_1: this.ruleForm.examOrder,
            //             sequence_mode: this.ruleForm.examWay,
            //             same_time: this.ruleForm.checked ? 1 : 0,
            //             real_push: this.ruleForm.realtime ? 0 : 1,
            //             time: objs
            this.ruleForm2.desc = examData.rules

            this.ruleForm = {
              name: examData.name,
              address: examData.address,
              parentId: examData.pid,
              checked: examData.same_time ? 1 : 0,
              examOrder: examData.sequence_cate,
              examWay: examData.sequence_mode,
              realtime: examData.real_push ? false : true,
            }
            this.timeList = examScreeningData.map((ele, index) => {
              return {
                begin_dt: ele.begin_dt,
                end_dt: ele.end_dt
              }
            });


          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    //获取考试的所有阶段
    allGradations() {

      this.$http.allGradations({
        exam_id: this.id
      })
        .then(res => {

          if (res.code !== 0) {
            this.gradationid = res.data[0].id;


          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取考站
    stationList() {

      this.$http.stationList({
        exam_id: this.id,
        id: this.id,
        exam_gradation_id: this.gradationid

      })
        .then(res => {
          if (res.code !== 0) {
            this.selectList = res.data;

          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取考试项目
      stationSubjects(row) {
      this.$http.stationSubjects({
        exam_id: this.id,
        station_id:row.station_id,
        subject_id:row.subject_id
      })
        .then(res => {
          if (res.code !== 0) {
            this.stationSubList = res.data;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取考试项目
    allSubjects(row) {
      this.$http.allSubjects({
        exam_id: this.id,
      })
        .then(res => {
          if (res.code !== 0) {
            this.subList = res.data;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    //获取考场
    getRoomList() {
      this.$http.roomList({
        exam_id: this.id,
        id: this.id,
        exam_gradation_id: this.gradationid,
        station_id: this.draft_id,
        order: 1,

      })
        .then(res => {
          if (res.code !== 0) {
            this.roomsList = res.data;
            // this.examArrangedata();

          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //invigilatesbysubject
    invigilatesbysubject(row) {
      this.$http.invigilatesbysubject({
        exam_id: this.id,
        type: 1,
        exam_gradation_id: row.exam_gradation_id,
        subject_id: row.subject_id
      })
        .then(res => {

          if (res.code !== 0) {
            this.TeachLists = res.data;
            // this.examArrangedata();
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    //获取考官安排
    examTeacherarrange() {
      this.$http.examTeacherarrange({
        exam_id: this.id,
      })
        .then(res => {
          if (res.code == 1) {
           const teachList = res.data.data;
            this.TeachList=teachList
            let arr = []
            for (let i = 0; i <teachList.length; i++) {
                let arr2 = []
              // arr = []
              for (let key in teachList[i].teacher) {
                let obj = {
                  name: teachList[i].teacher[key].teacher_name,
                  teacher_id: teachList[i].teacher[key].teacher_id
                }
                arr.push(obj)
                arr2.push(teachList[i].teacher[key].teacher_id)
              }
              this.teacherIds[i] = arr2
            }
            this.TeachLists = arr
              console.log(this.teacherIds)
              console.log( this.TeachLists)

          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    handleClick(tab, event) {
      console.log(tab.name);
        if (tab.name == 1) {
        }
        if (tab.name == 2) {
        }
        if (tab.name == 3) {
            this.examTeacherarrange()//考官列表
        }
        if (tab.name == 4) {
            this.getData()//获取考生列表
        }
        if (tab.name == 5) {
            this.showArrange()//智能排考回显数据
        }

      window.sessionStorage.setItem('tabIndex', tab.name);

    },
    godetele(index) {

      this.timeList.splice(index, 1)
    },
    blurTime(row) {

      var end = new Date(row.begin_dt).getTime() + 3 * 60 * 60 * 1000
      row.end_dt = new Date(end)
    },
    blurTime1(row) {
      return;
      if (row.end_dt && row.begin_dt) {
        console.log(new Date(row.end_dt) - new Date(row.begin_dt))
        if (new Date(row.end_dt) - new Date(row.begin_dt) > 0) {
          var ms = new Date(row.end_dt) - new Date(row.begin_dt)
          this.formatDuring(ms)
        }
      }


    },
    formatDuring(millisecond) {

      var days = parseInt(millisecond / (1000 * 60 * 60 * 24));

      var hours = parseInt((millisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

      var minutes = parseInt((millisecond % (1000 * 60 * 60)) / (1000 * 60));

      //   var seconds = (millisecond % (1000 * 60)) / 1000;

      return days + " 天 " + hours + " 小时 " + minutes + " 分钟 ";
      7
    },


    //新增时间
    addTime() {
      this.timeList.push({
        begin_dt: new Date(),
        end_dt: new Date((new Date().getTime() + 3 * 60 * 60 * 1000))
      })
    },
    // 获取全部的课程列表
    examsList() {
      this.$http.examsList({
        page_size: 10000,
        name: '',
        page: 1
      })
        .then(res => {


          this.option = res.data;

        })
        .catch(err => {
          console.log(err);
        })
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.timeList.length == 0) {
            this.$message.error("请选择考试时间")
            return false;
          }

          var arr = [];
          var objs = {};
          for (var i = 0; i < this.timeList.length; i++) {
            this.index = (i + 1).toString();
            this.timeList[i].begin_dt = this.$format(this.timeList[i].begin_dt, 'yyyy-MM-dd hh:mm')
            this.timeList[i].end_dt = this.$format(this.timeList[i].end_dt, 'yyyy-MM-dd hh:mm')
            var obj = {

            }

            objs[this.index.toString()] = this.timeList[i];
          }



          let params = {
            id: this.id,
            name: this.ruleForm.name,
            address: this.ruleForm.address,
            pid: this.ruleForm.parentId,
            sequence_cate_1: this.ruleForm.examOrder,
            sequence_mode: this.ruleForm.examWay,
            same_time: this.ruleForm.checked ? 1 : 0,
            real_push: this.ruleForm.realtime ? 0 : 1,
            time: objs

          };

          this.$http
            .addExam(params)
            .then(res => {
              this.$message.success("保存成功")


            })
            .catch(err => {
              console.log(err);
            });


        } else {
          this.$message.error("请填写必填项")
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$router.go(-1)
    },
    search() {
      this.pageform.pageNum = 1;
      this.getData()
    },
    // /新增考生
    addStudent() {
      this.$router.push({
        name: 'addStudent',
        query: {
          id: this.id
        }
      })
    },
    //编辑考生
    editStudent(item) {
      this.$router.push({
        name: 'addStudent',
        query: {
          id: this.id,
          studentId: item.id

        }
      })
    },
    //待考区保存
    examWaiting() {
      if (!this.ruleForm2.desc) {
        this.$message.error("请输入填写内容！");
        return false;
      }
      let params = {
        exam_id: this.id,
        rules: this.ruleForm2.desc

      };
      this.$http
        .examWaiting(params)
        .then(res => {
          if (res.code == 1) {
            this.$message.success("保存成功")
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 获取考生列表
    getData() {
      this.$http.studentsList({
        name: this.formInline.name,
        exam_id: this.id,
        page: this.pageform.pageNum,
        page_size: 10,
      })
        .then(res => {



          this.tableData = res.data;
          this.pageform.pages = res.meta.last_page;
          this.pageform.total = res.meta.total;
          //   if (res.code !== 0) {

          //     //   this.pageform.pageNum = res.meta.current_page;
          //   } else {
          //     this.$message.error(res.message)
          //   }
        })
        .catch(err => {
          console.log(err);
        })
    },
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      // console.log('当前页:'+ val);
      this.pageform.pageNum = val;
      this.getData();
    },
  },
};
</script>

<style  lang="less">
.examSeting {
  .firstUl {
    list-style: none;
    padding: 0;
    margin: 0;
    .zhanfirst {
      overflow: hidden;
      margin-bottom: 20px;
      .zhanname {
        float: left;
        display: flex;
        //   align-items: center;
        label {
          font-weight: bold;
          line-height: 40px;
          height: 40px;
        }
        .el-input {
          width: 150px;
        }
      }
      .name {
        float: left;
        margin-right: 40px;
        font-weight: bold;
        line-height: 40px;
        height: 40px;
      }
      .selectRight {
        float: right;
      }
    }
  }
  .addExam {
    .time {
      width: 174px !important;

      //   input{
      //      width:174px!important;
      //   }
    }
    .add {
      margin-bottom: 20px;
    }
    min-width: 600px;
    max-width: 1000px;
    .formItem {
      overflow: hidden;
      display: flex;
      .el-form-item {
      }
    }
  }
  .btngroup {
    margin-top: 20px;
    text-align: right;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .fwbWrap {
    //   height:400px;
    overflow: hidden;
    .el-form-item__content {
      height: 400px;
    }
  }
  .fwb {
    height: 300px;
  }
  .items {

  }
  .dialogs {
    .el-dialog {
      width: 600px;
    }

    .el-dialog__body {
      padding: 20px 20px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .btnbox {
    position: fixed;
    bottom: 80px;
    text-align: center;

    left: 200px;
    right: 0;
  }

  ul {
    list-style: none;
    padding: 0;
    margin-bottom: 0;
  }
  .ul1 {
    display: inline-block;
    margin-right: 20px;
  }
  .ul3 {
    border: 1px solid #ccc;
    width: 200px;
    display: inline-block;

    float: left;

    .li5 {
      height: 80px;
      border-bottom: 1px solid #ccc;
      padding: 4px 8px;
      box-sizing: border-box;
    }
  }
  .timeindex {
    // height: 70px;
    height: 80px;
    font-size: 12px;
    color: #696666;
  }
  .ulleft {
    // display: inline-block;
    float: left;
  }
  .roomName {
    background: #ccc;
    line-height: 40px;
    height: 40px;
    text-align: center;
  }
  .roomName1 {
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/examManage/examSeting.vue